import {View} from 'react-native'
import {Trans, useLingui} from '@lingui/react/macro'
import {useNavigation} from '@react-navigation/native'

import {
  type CommonNavigatorParams,
  type NativeStackScreenProps,
  type NavigationProp,
} from '#/lib/routes/types'
import {atoms as a, useTheme} from '#/alf'
import {Button, ButtonText} from '#/components/Button'
import {CircleCheck_Stroke2_Corner0_Rounded as CircleCheckIcon} from '#/components/icons/CircleCheck'
import * as Layout from '#/components/Layout'
import {Text} from '#/components/Typography'

type Props = NativeStackScreenProps<CommonNavigatorParams, 'TopupSuccess'>

export function TopupSuccessScreen({}: Props) {
  const t = useTheme()
  const {t: l} = useLingui()
  const navigation = useNavigation<NavigationProp>()

  return (
    <Layout.Screen>
      <Layout.Header.Outer>
        <Layout.Header.BackButton />
        <Layout.Header.Content>
          <Layout.Header.TitleText>
            <Trans>Payment</Trans>
          </Layout.Header.TitleText>
        </Layout.Header.Content>
      </Layout.Header.Outer>
      <Layout.Content>
        <Layout.Center>
          <View
            style={[
              a.flex_1,
              a.align_center,
              a.justify_center,
              a.gap_2xl,
              a.px_2xl,
              a.py_4xl,
            ]}>
            <CircleCheckIcon
              size="xl"
              style={{color: t.palette.positive_500}}
            />
            <View style={[a.align_center, a.gap_md]}>
              <Text
                style={[a.text_2xl, a.font_bold, a.text_center, t.atoms.text]}>
                <Trans>Payment Successful</Trans>
              </Text>
              <Text
                style={[
                  a.text_md,
                  a.text_center,
                  t.atoms.text_contrast_medium,
                ]}>
                <Trans>
                  Your wallet has been topped up. You're all set to continue
                  enjoying the platform.
                </Trans>
              </Text>
            </View>
            <Button
              label={l`Go to Wallet`}
              color="primary"
              size="large"
              onPress={() => navigation.navigate('Wallet')}>
              <ButtonText>
                <Trans>Go to Wallet</Trans>
              </ButtonText>
            </Button>
          </View>
        </Layout.Center>
      </Layout.Content>
    </Layout.Screen>
  )
}
